module.exports = __webpack_public_path__ + "media/images/WFC_Award_Black-bb741cebb03c4a8dcabbe1ea9096ee86.png";